export const REQUEST_TIMEOUT = 408;